import React,{useState,useEffect} from "react";
import { useField } from "formik";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  Radio,
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";

interface Props {
  label: string;
  name: string;
  options: Array<{
    is_selected: boolean | undefined;
    label: string;
    value: string;
  }>;
  display_format: {
    type: string;
    column: string;
  };
  onChange:(field:any)=>void;
  formField:any,
  isRequired?:any
}

const RadioField: React.FC<Props> = ({
  label,
  name,
  options,
  display_format,
  onChange,
  formField,
  isRequired
}) => {
  const [field, meta, helpers] = useField(name);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const defaultValue = options.find((option) => option.is_selected)?.value || "";

  useEffect(()=>{
    onChange({...formField,value:defaultValue})
  },[defaultValue])
  
  const handleValueChange=(value:string)=>{
   onChange({...formField,value:value,options:  formField.options.map((option: { label: string; }) => ({
        ...option,
    is_selected: option.label === value
  }))})
  }

  return (
    <FormControl>
      <FormLabel id={`${name}-label`}>{`${label} ${isRequired ? "*":""}`}</FormLabel>
      <RadioGroup
        aria-labelledby={`${name}-label`}
        name={name}
        value={field.value}
        onChange={(event) => {
          helpers.setValue(event.target.value)
          handleValueChange(event.target.value)
        }}
      >
        <Stack direction={isMobile ? "column" : "row"}>
          {options?.map((option, index) => (
            <FormControlLabel
              key={index}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </Stack>
      </RadioGroup>
      {meta.touched && meta.error ? (
        <Typography component={"span"} style={{ color: "red" }}>
          {meta.error}
        </Typography>
      ) : null}
    </FormControl>
  );
};

export default RadioField;
